module.exports = __webpack_public_path__ + "img/2025-07-21a_3.ccdff0a8.jpg";